import React from 'react';
import ListItem from 'components/ListItem';
import { SprayEventTechnicalPersonName } from 'services/sprayEvents/types';

export interface OwnProps {
    technicalPersonName: SprayEventTechnicalPersonName;
}

type Props = OwnProps;

export default class SummaryApplicationTechnicalPersonName extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { technicalPersonName } = this.props;

        return (
            <ListItem
                description="Responsible person"
                value={technicalPersonName}
            />
        );
    }
}
